<template>
    <div class="content form-group">
        <div class="row">
            <div class="col-md-12 stage">
                <!--<roqquter-link tag="div" class="text-center rounded visit-profile-btn font-weight-bold prepare-control box bounce-1" :to="{ name: 'financial-reports-templates' }">
                    <i class="fa fa-table fa-large mr-2"></i>{{ $t("newPublications") | upperCase  }}
                </roqquter-link>-->
                <a class="text-center rounded visit-profile-btn font-weight-bold box bounce-1" style="background-color: #d4af37; color: #000;" href="bs/content/4862/fbih-poslovanje-pravnih-lica-u-2021-godini">
                    <i class="fa fa-table fa-large mr-2"></i>{{ $t("newPublications") | upperCase  }}
                </a>
                <hr />
            </div>
            <div class="col-md-12 stage">
                <router-link tag="div" class="text-center rounded visit-profile-btn font-weight-bold prepare-control box bounce-1" :to="{ name: 'financial-reports-templates' }">
                    <i class="fa fa-table fa-large mr-2"></i>{{ $t("prepareControlFR") | upperCase  }}
                </router-link>
                <hr />
            </div>
        </div>
        <hr />
        <div class="row">
            <div class="col-md-12">
                <span class="font-weight-bold d-inline-block title mt-1"><i class="fa fa-building fa-large mr-2"></i> {{ $t("businessEntitiesProfile") | upperCase }}</span>
                <hr />
                <img src="../../assets/legal-entity-profile.jpg" class="rounded mb-3 business-entities-profile-img" />
                <span class="text-justify text-muted small" v-html="$t('businessEntityProfileHomepageDescription')"></span>
                <hr />
                <router-link tag="div" class="text-center rounded visit-profile-btn font-weight-bold" :to="{ name: 'profil-pravnih-lica' }">
                    <i class="fa fa-search mr-2"></i>{{ $t("searchLegalEntities") | upperCase  }}
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        filters: {
            upperCase(value) {
                return value.toUpperCase();
            }
        }
    }
</script>

<style scoped>
    .content {
        border-radius: 5px;
        padding: 5%;
        box-shadow: 0px 2px 6px 1px rgba(0,0,0,0.15);
        font-size: 20px;
    }

     .visit-profile-btn:hover {
            background-color: #334C61;
        }

    .visit-profile-btn {
        background-color: #253746;
        color: #FFFFFF;
        cursor: pointer;
        padding: 3%;
    }

    .logo {
        height: 20px;
        width: 20px;
    }

    .content {
        font-size: 15px;
    }

    .fa-large {
        font-size: 20px;
    }

    .business-entities-profile-img {
        width: 100%;
    }

    .prepare-control {
        background-color: #C82333;
    }
        .prepare-control:hover {
            background-color: #F72A3F;
        }

    .stage {
        margin-bottom:10px;
        display: flex;
        width: 100%;
    }

    .box {
        align-self: flex-end;
        animation-duration: 1.3s;
        animation-iteration-count: infinite;
        margin: 0 auto 0 auto;
        transform-origin: bottom;
    }

    .bounce-1 {
        animation-name: bounce-1;
        animation-timing-function: ease-in-out;
    }

    @keyframes bounce-1 {
        0% {
            transform: scale(1,1) translateY(0);
        }

        10% {
            transform: scale(1,1) translateY(0);
        }

        30% {
            transform: scale(1,1) translateY(-15px);
        }

        50% {
            transform: scale(1,1) translateY(0);
        }

        57% {
            transform: scale(1,1) translateY(0);
        }

        64% {
            transform: scale(1,1) translateY(0);
        }

        100% {
            transform: scale(1,1) translateY(0);
        }
    }

</style>
